export enum ErrorMessageCodes {
  UnspecifiedError = 1000,
  ServerError,
  InputModel,
  Transaction,
  NotFound,
  Duplicate,
  NotPermitted
}
